import { render, staticRenderFns } from "./LobbyPreMeeting.vue?vue&type=template&id=6b564844"
import script from "./LobbyPreMeeting.vue?vue&type=script&lang=js"
export * from "./LobbyPreMeeting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b564844')) {
      api.createRecord('6b564844', component.options)
    } else {
      api.reload('6b564844', component.options)
    }
    module.hot.accept("./LobbyPreMeeting.vue?vue&type=template&id=6b564844", function () {
      api.rerender('6b564844', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LobbyPreMeeting.vue"
export default component.exports